
import { defineComponent, watch, ref, onMounted } from 'vue';
import PaginationItem from './PaginationItem.vue';
import { generateItemList } from './utils';

export default defineComponent({
  name: 'Pagination',
  components: {
    PaginationItem,
  },
  props: {
    currentPage: Number,
    totalPages: Number,
  },
  emits: ['go-to-page'],
  setup(props, { emit }) {
    const disableFirst = ref<boolean>(false);
    const disableLast = ref<boolean>(false);
    const pageList = ref<(string | number)[]>([]);

    const updatePrevNextBtn = () => {
      if (props.currentPage === 1) {
        disableFirst.value = true;
      } else {
        disableFirst.value = false;
      }

      if (props.currentPage === props.totalPages) {
        disableLast.value = true;
      } else {
        disableLast.value = false;
      }
    };

    const generatePageList = () => {
      const count = props.totalPages;
      const page = props.currentPage;
      if (count && page) {
        pageList.value = generateItemList(count, page);
      }
    };

    watch(
      () => [props.currentPage, props.totalPages],
      () => {
        generatePageList();
        updatePrevNextBtn();
      }
    );

    const goToPage = (pageNumber: number) => {
      if (typeof pageNumber !== 'number') return;

      emit('go-to-page', pageNumber);
    };

    onMounted(() => {
      generatePageList();
      updatePrevNextBtn();
    });

    return {
      goToPage,
      disableFirst,
      disableLast,
      pageList,
    };
  },
});
